import React, { forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';

// eslint-disable-next-line prefer-arrow-callback
const FilterPills = forwardRef(function FilterPills({ active, options, className, onChange }, ref) {
  return (
    <div ref={ref} className={cx('filter-pills', className)}>
      {options.map(({ label, title, value }) => {
        const isActive = active === value;

        return (
          <div
            key={value}
            className={cx('filter-pills__item', { active: isActive })}
            data-value={value}
            onClick={() => !isActive && onChange?.(value)}
          >
            <span data-title={title} className="filter-pills__item-label">
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
});

FilterPills.propTypes = {
  active: T.string,
  options: T.arrayOf(
    T.shape({
      label: T.oneOfType([T.string, T.node]).isRequired,
      title: T.string,
      value: T.string.isRequired,
    })
  ).isRequired,
  className: T.string,
  onChange: T.func,
};

export default FilterPills;
